import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { CountRendereProps } from '../../../common/ui/types';
import IssueCountRenderer from './issue-count-renderer/main.tsx';
import { PaginationControls } from './pagination-controls/main.tsx';

type Props = {
	currentPage: number;
	totalPages: number;
	countRendererData: CountRendereProps;
};

export const FooterRenderer = ({ currentPage, totalPages, countRendererData }: Props) => (
	<FooterContainer data-testid="issue-archival-archives.ui.archives-table.footer-renderer.footer-container">
		{SpacerElement}
		<IssueCountRenderer
			issueNavigatorPageInfo={countRendererData.issueNavigatorPageInfo}
			totalIssueSearchResultCount={countRendererData.totalIssueSearchResultCount}
		/>
		<PaginationControls currentPage={currentPage} totalPages={totalPages} />
	</FooterContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterContainer = styled.div({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	position: 'sticky',
	left: 0,
	bottom: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface', colors.N0),
	padding: `${token('space.075', '6px')} ${token('space.025', '2px')}`,

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `1px solid ${token('color.border', colors.N40)}`,
	borderBottomLeftRadius: token('space.100', '8px'),
	borderBottomRightRadius: token('space.100', '8px'),
	borderTop: 'none',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Spacer = styled.div({
	display: 'flex',
	flex: 1,
});

const SpacerElement = <Spacer />;
